export const AiAgentEvaluationCriteriaStatusName  = {
  Success: 'Success',
  Failure: 'Failure',
  Unknown: 'Unknown'
}
